import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { environment } from '../../../../src/environments/environment'; 

@Directive({
  selector: '[appModifyMoodleLinks]'
})
export class ModifyMoodleLinksDirective implements AfterViewInit {

  private observer!: MutationObserver;

  private moodleDomain = "https://moodle.bgu.ac.il/";
  private moodleLinkSelector = `a[href^="${this.moodleDomain}"]:not([modified-moodle-link])`;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.modifyLinks();
    this.observeDomChanges();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private modifyLinks(nodes?: HTMLElement[]) {
    // Use the provided nodes or query for the default set of links
    const links = nodes ?? Array.from(
      this.el.nativeElement.parentElement.querySelectorAll(this.moodleLinkSelector)
    );

    links.forEach((link: HTMLElement) => {
      const originalUrl = link.getAttribute('href');
      const modifiedAttrExist = link.hasAttribute('modified-moodle-link');
  
      if (!originalUrl || modifiedAttrExist) return; // Skip if no URL exists
      const newUrl = environment.apiUrl + "/moodle/redirectToMoodle?url=" + encodeURIComponent(originalUrl);
  
      this.renderer.setAttribute(link, 'href', newUrl);
      this.renderer.setAttribute(link, 'modified-moodle-link', '');
    });
  }

  private observeDomChanges() {
    const observer = new MutationObserver((mutations) => {
      const addedLinks: HTMLElement[] = [];
  
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if ((node as HTMLElement).matches?.(this.moodleLinkSelector)) {
            // If the node itself is a link
            addedLinks.push(node as HTMLElement);
          } else if ((node as HTMLElement).querySelectorAll) {
            // If the node contains links, query them and cast to HTMLElement
            addedLinks.push(
              ...Array.from(
                (node as HTMLElement).querySelectorAll(this.moodleLinkSelector)
              ).map((el) => el as HTMLElement)
            );
          }
        });
      });

      if (addedLinks.length > 0) {
        // Ensure addedLinks contains only distinct elements
        const distinctLinks = Array.from(new Set(addedLinks));

        this.modifyLinks(distinctLinks); // Pass only the collected links
      }
    });
  
    observer.observe(this.el.nativeElement.parentElement, {
      childList: true,
      subtree: true,
    });
  }
}
